import { eur } from "@/lib/api";

const STATUS_LABELS = { rozpracovana: "Rozpracovaná", neuhradena: "Neuhradená", dokoncena: "Uhradená" };

export default function JobPrint({ job, settings }) {
  if (!job) return null;
  const s = settings || {};
  const c = job.customer || {};
  const v = job.vehicle || {};
  const items = job.items || [];
  const rc = job.vat_mode === "RC";
  let subtotal = 0, vat = 0;
  items.forEach((it) => {
    const line = Number(it.qty || 0) * Number(it.unit_price || 0) * (1 - Number(it.discount || 0) / 100);
    subtotal += line;
    vat += rc ? 0 : line * Number(it.vat_rate || 0) / 100;
  });
  const total = subtotal + vat;

  return (
    <div className="print-page mx-auto max-w-[800px] rounded-lg bg-white p-8 text-slate-900 shadow-xl" data-testid="job-print-area">
      <div className="flex items-start justify-between border-b-2 border-slate-900 pb-4">
        <div className="flex items-center gap-3">
          {s.logo && <img src={s.logo} alt="logo" className="h-16 w-auto" />}
          <div>
            <div className="text-xl font-extrabold uppercase" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>{s.name || "Váš servis"}</div>
            <div className="text-xs text-slate-600">{s.address}{s.psc || s.city ? `, ${s.psc || ""} ${s.city || ""}` : ""}</div>
            <div className="text-xs text-slate-600">IČO: {s.ico || "—"} · DIČ: {s.dic || "—"}{s.ic_dph ? ` · IČ DPH: ${s.ic_dph}` : ""}</div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-2xl font-extrabold uppercase" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>Zákazka</div>
          <div className="text-lg font-bold">č. {job.number}</div>
          <div className="text-xs text-slate-600">Stav: {STATUS_LABELS[job.status] || job.status}</div>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-6 text-sm">
        <div>
          <div className="mb-1 text-xs font-bold uppercase text-slate-500">Zákazník</div>
          <div className="font-semibold">{c.name || "—"}</div>
        </div>
        <div className="text-sm">
          <div className="flex justify-between"><span className="text-slate-500">Názov zákazky:</span><span className="font-semibold">{job.title}</span></div>
          <div className="flex justify-between"><span className="text-slate-500">Dátum:</span><span>{(job.created_at || "").slice(0, 10)}</span></div>
          {v.spz && <div className="flex justify-between"><span className="text-slate-500">Vozidlo:</span><span>{v.spz} · {v.brand} {v.model}</span></div>}
          {v.vin && <div className="flex justify-between"><span className="text-slate-500">VIN:</span><span className="font-mono text-xs">{v.vin}</span></div>}
          {job.odometer_km != null && <div className="flex justify-between"><span className="text-slate-500">Tachometer:</span><span>{Number(job.odometer_km).toLocaleString("sk-SK")} km</span></div>}
        </div>
      </div>

      <table className="mt-6 w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-slate-300 text-left text-xs uppercase text-slate-500">
            <th className="py-2">Popis</th><th className="py-2 text-right">Množ.</th><th className="py-2 text-right">Cena/j.</th><th className="py-2 text-right">Zľava</th>
            {!rc && <th className="py-2 text-right">DPH%</th>}<th className="py-2 text-right">Spolu</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, i) => (
            <tr key={i} className="border-b border-slate-100">
              <td className="py-2">{it.description}</td>
              <td className="py-2 text-right">{it.qty} {it.unit}</td>
              <td className="py-2 text-right">{eur(it.unit_price)}</td>
              <td className="py-2 text-right">{Number(it.discount || 0) ? `${Number(it.discount)}%` : "—"}</td>
              {!rc && <td className="py-2 text-right">{it.vat_rate}%</td>}
              <td className="py-2 text-right font-medium">{eur(Number(it.qty) * Number(it.unit_price || 0) * (1 - Number(it.discount || 0) / 100))}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-4 flex justify-end">
        <div className="w-64 space-y-1 text-sm">
          <div className="flex justify-between"><span className="text-slate-500">Základ dane</span><span>{eur(subtotal)}</span></div>
          <div className="flex justify-between"><span className="text-slate-500">DPH{rc ? " (prenesenie)" : ""}</span><span>{eur(vat)}</span></div>
          <div className="flex justify-between border-t-2 border-slate-900 pt-2 text-lg font-extrabold"><span>Spolu</span><span>{eur(total)}</span></div>
        </div>
      </div>

      {job.note && <div className="mt-4 text-xs text-slate-500">Poznámka: {job.note}</div>}
    </div>
  );
}
